import { ACCENT, illustrationA11y, lineStyle } from './static-art';

export function SendIllustration(props: { className?: string; label?: string; ink?: string }) {
	const line = lineStyle(props.ink, 1.5);
	return (
		<svg
			width="234"
			height="224.25"
			viewBox="0 0 234 224.25"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M16.1665 76.5672C38.3949 69.9088 174.815 29.4468 214.321 27.2952C217.403 27.1287 219.564 30.2853 218.27 33.0874C208.597 54.0027 173.671 128.284 140.379 183.675C139.599 184.972 137.774 185.12 136.791 183.967L109.923 152.463L86.6003 124.887L105.657 147.463L70.6696 171.344C69.7756 171.955 68.5487 171.406 68.4131 170.33L60.5063 108.762L15.7719 79.2583C14.7084 78.5554 14.9458 76.934 16.1665 76.5672Z"
				{...line}
			/>
			<path d="M60.5055 108.759L216.869 28.0042" {...line} />
			<path d="M70.672 171.341L86.5997 124.883L218.531 30.4024" {...line} />
			<path
				d="M16.0616 160.987L49.6185 138.832"
				stroke={ACCENT}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M6.44366 186.677L40.0006 164.523"
				stroke={ACCENT}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M23.2217 196.908L56.7787 174.75"
				stroke={ACCENT}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
		</svg>
	);
}
